// extracted by mini-css-extract-plugin
module.exports = {"body":"_ad53bae","button":"_4bad84f"};